import React, { useState } from "react";
import { Popup, TextBox, Button } from "devextreme-react";

const NewAppNameModal = ({ visible, onHide, addNewAppName }) => {
  const [name, setName] = useState("");
  return (
    <Popup
      visible={visible}
      onHiding={onHide}
      title='Add New Application'
      width='500px'
      height='250px'
      showCloseButton
    >
      <div>
        <TextBox
          placeholder='Application Name'
          value={name}
          valueChangeEvent='keyup'
          onValueChanged={(e) => {
            setName(e.value);
          }}
        />

        <Button
          stylingMode='contained'
          type='default'
          text='Add application'
          className='mt-4'
          onClick={() => addNewAppName(name)}
        />
      </div>
    </Popup>
  );
};

export default NewAppNameModal;
